import { render, staticRenderFns } from "./digitalHuman_3d.vue?vue&type=template&id=1c84f373&scoped=true"
import script from "./digitalHuman_3d.vue?vue&type=script&lang=js"
export * from "./digitalHuman_3d.vue?vue&type=script&lang=js"
import style0 from "./digitalHuman_3d.vue?vue&type=style&index=0&id=1c84f373&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c84f373",
  null
  
)

export default component.exports